module.exports = "//static.hsappstatic.net/marketplace-storefront-base/static-1.7312/assets/images/breeze-assistants.jpg"